import { ThunkDispatch } from 'redux-thunk';
import { toast } from 'common/helpers/toastConfig';
import { RootState } from 'redux/reducers';
import { AnyAction } from 'redux';

import * as types from 'common/constants';
import * as services from 'common/services';

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * Erp list actions
 */
export const erpRequestAction = (data: { page: number; size: number }) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.ERP.REQUEST,
        payload: {}
      });

      const response: any = await services.erpService(data);

      if (response.status === 200 || response.status === 201) {
        dispatch(erpSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(erpFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(erpFailureAction(error));
      throw error;
    }
  };
};

export const erpSuccessAction = (data: object) => {
  return {
    type: types.ERP.SUCCESS,
    payload: data
  };
};

export const erpFailureAction = (error: object) => {
  return {
    type: types.ERP.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/

/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---
 * Erp Detail actions
 */
export const erpDetailRequestAction = (id?: string) => {
  return async (dispatch: ThunkDispatch<RootState, void, AnyAction>) => {
    try {
      dispatch({
        type: types.ERP_DETAIL.REQUEST,
        payload: {}
      });

      const response: any = await services.erpDetailService(id);

      if (response.status === 200 || response.status === 201) {
        dispatch(erpDetailSuccessAction(response.data?.data));
      } else {
        toast({ model: 'error', message: response.data?.clientMessage || 'No client message available' });
        dispatch(erpDetailFailureAction(response.data));
      }
    } catch (error: any) {
      console.log(error);
      dispatch(erpDetailFailureAction(error));
      throw error;
    }
  };
};

export const erpDetailSuccessAction = (data: object) => {
  return {
    type: types.ERP_DETAIL.SUCCESS,
    payload: data
  };
};

export const erpDetailFailureAction = (error: object) => {
  return {
    type: types.ERP_DETAIL.FAILURE,
    payload: error
  };
};
/** ⸻⸻⸻⸻⸻⸻⸻⸻⸻---*/
